import React, { useContext } from 'react';
import { Spinner } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const LoadingState: React.FC = () => {
  const i18n = useContext(I18nContext);
  return <Spinner label={i18n.getString(_TL_('Loading invitation details'))} />;
};
